import { CountUnitConverter } from './base/CountUnitConverter';
import { QuantityResult } from './types';

export type CountPolicy = (value: number, unit: string) => QuantityResult;

export const CountPolicies: Record<
  'countConversionEnabled' | 'countConversionDisabled',
  CountPolicy
> = {
  countConversionEnabled: (value, unit) => {
    const { quantity, countUnit } = CountUnitConverter.getInstance().convertToBestUnit(value, '');
    return { quantity, countUnit, unit };
  },
  countConversionDisabled: (value, unit) => {
    return { quantity: value, countUnit: '', unit };
  },
};

// useCountUnit → CountPolicy. true/미지정은 undefined(converter 기본값 존중: Money 등
// 기본 disabled 보존), false만 disabled. enabled를 명시 전달하면 Money 약어가 깨진다.
export const countPolicyFromOption = (enabled?: boolean): CountPolicy | undefined =>
  enabled === false ? CountPolicies.countConversionDisabled : undefined;
